import { render, staticRenderFns } from "./DEVELOPERS.vue?vue&type=template&id=74eb0791&"
import script from "./DEVELOPERS.vue?vue&type=script&lang=js&"
export * from "./DEVELOPERS.vue?vue&type=script&lang=js&"
import style0 from "./DEVELOPERS.vue?vue&type=style&index=0&id=74eb0791&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports